export const API_KEY_GET_BRANDS_LIST = "API_KEY_GET_BRANDS_LIST";
export const API_GET_BRANDS_LIST = "/api/admin/brands/list";
export const REPORT_STATE_SELECTOR = "reportGamersFTD";
export const REPORT_COLUMNS_KEY = "[REPORT ==> gamers-ftd] Visible columns is:";
export const REPORT_DATE_KEY = "[REPORT ==> gamers-ftd] Date range is: ";
